const percentage = (answered = 0, total = 1) => {
  if (total === 0) return 100
  return (answered / total) * 100
}

export default percentage
